import React from "react";

const Hero = () => {
  return (
    <section id="hero" className="d-flex align-items-center">
      <div className="container-fluid" data-aos="fade-up">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10 text-center">
            <h1>Careers at Techport13</h1>
            <h2>
              We are a team of talented consultants and developers bringing our client's dreams to life.
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
